import * as Yup from 'yup';

export const BAFilterSchema = Yup.object().shape({
  startDate: Yup.string(),
  endDate: Yup.string(),
  status: Yup.string(),
});

export type BAFilterDataType = Yup.InferType<typeof BAFilterSchema>;

type InitialValues = {
  startDate: string;
  endDate: string;
  status: string;
};

export const BAFilterSchemaInitialValues: InitialValues = {
  startDate: '',
  endDate: '',
  status: '',
};

export interface IBAFilterResponse {}

export interface IBAFilterRequest {
  status: string;
  role: string;
}
